import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { TransactionDetailProps } from "./TransactionDetailProps";
import { formatDate, formatTime } from "../../history.utils";
import styles from "../customer-transaction-history-detail.module.scss";
import { CopyIcon } from "../../../../../assets/icons";
import { formatCurrency, getTransactionStatusInfo, handleCopy } from "../../../../../utils";
import { TransactionReceiptHeader } from "./TransactionReceiptHeader";
import { BillingDetails, Transaction, TransactionCategory, VendingDetails } from "../../../../../model/transaction";

export const BulkPurchaseTransactionDetail = ({
  transaction,
  onDownloadReceipt: _onDownloadReceipt,
  isDownloading: _isDownloading,
}: TransactionDetailProps) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const bulk = transaction.bulkPurchaseDetails;
  const { key, label } = getTransactionStatusInfo(transaction.status);

  const handleBillingClick = (item: BillingDetails) => {
    const ref = item.reference || item.id;
    const wrapped: Transaction = {
      ...transaction,
      reference: ref,
      amount: item.amount,
      billingDetails: item,
      bulkPurchaseDetails: undefined,
    };
    navigate(`/history/${ref}`, {
      state: { category: TransactionCategory.BillingTransaction, transaction: wrapped },
    });
  };

  const handleVendingClick = (item: VendingDetails) => {
    const wrapped: Transaction = {
      ...transaction,
      reference: item.transactionReference ?? transaction.reference,
      amount: item.amount ?? transaction.amount,
      vendingDetails: item,
      bulkPurchaseDetails: undefined,
    };
    navigate(`/history/${item.transactionReference ?? transaction.reference}`, {
      state: { category: TransactionCategory.VendingTransaction, transaction: wrapped },
    });
  };

  return (
    <>
      {/* <TransactionReceiptHeader
        status={transaction.status}
        amount={transaction.amount?.amount ?? 0}
        currency={transaction?.amount?.currency}
        createdAt={transaction.createdAt}
      /> */}

      <div className={styles.detailsCard}>

        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("buyElectricity.totalAmount")}</span>
          <span className={styles.detailValue}>
            {transaction?.amount ? formatCurrency(transaction.amount.amount, { currency: transaction.amount.currency }) : t("history.web.notApplicable")}
          </span>
        </div>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("common.labels.date")}</span>
          <span className={styles.detailValue}>
            {transaction.createdAt ? `${formatDate(transaction.createdAt)}, ${formatTime(transaction.createdAt).toLocaleLowerCase()}` : t("history.web.notApplicable")}
          </span>
        </div>
      </div>

      <div className={styles.transactionsListBulk}>
        {bulk?.billingDetailsList.map((x, i) => (
          <div key={i} className={styles.bulkTransactionItem} onClick={() => handleBillingClick(x)}>
            <div className={styles.bulkTransactionItemLeft}>
              <span className={styles.bulkTransactionItemLabel}>{t("common.labels.accountNumber")}</span>
              <span className={styles.bulkTransactionItemNumber}>{x.accountNumber || t("history.web.notApplicable")}</span>
            </div>
            <div className={styles.bulkTransactionItemRight}>
              <span className={styles.bulkTransactionItemRightAmount}>
                {x.amount ? formatCurrency(x.amount.amount, { currency: x.amount.currency }) : t("history.web.notApplicable")}
              </span>
              <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                <span className={`${styles.bulkTransactionItemRightType} ${styles.bulkTypePostpaid}`}>{t("common.labels.postpaid")}</span>
                <span className={`${styles.statusBadge} ${styles[key]} ${styles.statusLabel}`}>{label}</span>
              </div>
            </div>
          </div>
        ))}
        {bulk?.vendingDetailsList.map((x, i) => (
          <div key={i} className={styles.bulkTransactionItem} onClick={() => handleVendingClick(x)}>
            <div className={styles.bulkTransactionItemLeft}>
              <span className={styles.bulkTransactionItemLabel}>{t("common.labels.meterNumber")}</span>
              <span className={styles.bulkTransactionItemNumber}>{x.meterNumber || x.accountNumber || t("history.web.notApplicable")}</span>
            </div>
            <div className={styles.bulkTransactionItemRight}>
              <span className={styles.bulkTransactionItemRightAmount}>
                {x.amount ? formatCurrency(x.amount.amount, { currency: x.amount.currency }) : t("history.web.notApplicable")}
              </span>
              <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
                <span className={`${styles.bulkTransactionItemRightType} ${styles.bulkTypePrepaid}`}>{t("common.labels.prepaid")}</span>
                <span className={x.vendingToken?.token ? styles.bulkTransactionItemRightToken : styles.bulkTransactionItemRightFailed}>
                  {x.vendingToken?.token ? t("history.web.tokenAvailable") : t("history.web.notAvailable")}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className={styles.footer}>
        <div className={styles.detailRow}>
          <span className={styles.detailLabel}>{t("history.web.transactionId")}</span>
          <div className={styles.copyContainer}>
            <span className={styles.detailValue}>{transaction.reference || t("history.web.notApplicable")}</span>
            {transaction.reference && (
              <CopyIcon onClick={() => handleCopy(transaction.reference)} className={styles.copyBtn} />
            )}

          </div>
        </div>
      </div>
    </>
  );
};